// src/state/timeState.js

export function readTimeSnapshot() {
  const nowLocalMs =
    typeof Date !== "undefined" ? Date.now() : 0;

  // 브라우저 Date epoch 자체는 UTC epoch(ms)이므로 "로컬/UTC"는 표시 방식 차이임.
  // 여기선 "서버 기준 시간"이 있을 때 drift/offset 계산을 위해 anchor를 유지한다.
  const tzOffsetMin =
    typeof Date !== "undefined" ? new Date().getTimezoneOffset() : 0;

  const locale =
    typeof navigator !== "undefined" ? (navigator.language || "en") : "en";

  return {
    // 클라이언트 기준 anchor
    anchorLocalMs: nowLocalMs,

    // 서버 시간 anchor(없으면 클라이언트 시간으로 시작)
    anchorServerUtcMs: nowLocalMs,

    // 서버-클라 오프셋(ms): serverUtc - localNow
    serverOffsetMs: 0,

    tzOffsetMin,
    locale,
    lastServerSyncAtMs: nowLocalMs,
  };
}

// 서버 UTC 시간을 받아서 offset을 갱신하는 helper
export function computeServerSync(prev, serverUtcIsoOrMs) {
  const nowLocalMs = Date.now();
  const serverUtcMs =
    typeof serverUtcIsoOrMs === "number"
      ? serverUtcIsoOrMs
      : new Date(serverUtcIsoOrMs).getTime();

  if (!Number.isFinite(serverUtcMs)) {
    return prev; // invalid -> ignore
  }

  const offset = serverUtcMs - nowLocalMs;

  return {
    ...prev,
    anchorLocalMs: nowLocalMs,
    anchorServerUtcMs: serverUtcMs,
    serverOffsetMs: offset,
    lastServerSyncAtMs: nowLocalMs,
  };
}

// "지금"을 매초 state로 저장하지 않고 계산해서 제공
export function nowServerUtcMs(timeState) {
  const nowLocalMs = Date.now();
  return nowLocalMs + (timeState?.serverOffsetMs || 0);
}

export function timeReducer(state, action) {
  switch (action.type) {
    case "TIME/SERVER_SYNC": {
      return computeServerSync(state, action.payload);
    }
    case "TIME/REFRESH_META": {
      // tz/locale 같은 메타 갱신
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}
